"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
class Path {
    static removeAnyWrappingForwardSlash(str) {
        if (str.startsWith('/')) {
            return Path.removeAnyWrappingForwardSlash(str.slice(1));
        }
        if (str.endsWith('/')) {
            return Path.removeAnyWrappingForwardSlash(str.slice(0, -1));
        }
        return str;
    }
    static baseIsValid(base) {
        return base.startsWith('https://') || base.startsWith('http://') || base.startsWith('.');
    }
    static buildPath(basePath, route) {
        const trimmedBase = Path.removeAnyWrappingForwardSlash(basePath);
        const trimmedRoute = Path.removeAnyWrappingForwardSlash(route);
        const prefix = Path.baseIsValid(basePath) ? '' : '/';
        if (trimmedBase == '' && trimmedRoute == '')
            return '/';
        if (trimmedRoute == '')
            return `${prefix}${trimmedBase}`;
        if (trimmedBase != '' && trimmedRoute != '')
            return `${prefix}${trimmedBase}/${trimmedRoute}`;
        return `${prefix}${trimmedRoute}`;
    }
    static addQueryParam(absoluteUrl, key, value) {
        const [beforeHash, afterHash] = absoluteUrl.split('#');
        const [before, after] = beforeHash.split('?');
        var searchParams = new URLSearchParams(after);
        searchParams.set(key, value);
        var newUrlWithQueryParam = before + '?' + searchParams.toString() + (afterHash ? `#${afterHash}` : '');
        return newUrlWithQueryParam;
    }
    static hasHashtag(absoluteUrl) {
        return absoluteUrl.includes('#');
    }
    static setVizzlyHashtagValue(absoluteUrl, value) {
        return `${absoluteUrl}#vizzly_${value}`;
    }
    static getVizzlyHashtagValue(absoluteUrl) {
        return absoluteUrl.split('#vizzly_')[1] || null;
    }
}
exports.Path = Path;
